define('utils/guid',[],function(){
    return function () {return 'id-' + (Math.random() * (1 << 30)).toString(16).replace('.', '')}
})
;
